/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Paymarket } from './Paymarket';
import type { Plan } from './Plan';
import type { SurveyDataCut } from './SurveyDataCut';
import type { SurveyJobProfile } from './SurveyJobProfile';
import type { SurveyReplacement } from './SurveyReplacement';
import type { SurveyStatus } from './SurveyStatus';
import type { SurveyVendor } from './SurveyVendor';

export type Survey = {
    id: string;
    code?: string;
    name: string;
    files?: Array<Record<string, any>> | null;
    surveyVendorId: string;
    surveyVendor?: (SurveyVendor | Record<string, any> | null);
    surveyJobProfile?: (SurveyJobProfile | Record<string, any> | null);
    SurveyDataCuts?: Array<SurveyDataCut> | null;
    plans?: Array<Plan> | null;
    paymarkets?: Array<Paymarket> | null;
    surveyJobProfileId: string;
    participationId?: string | null;
    version?: string | null;
    public?: boolean;
    effectiveDate?: string | null;
    status?: SurveyStatus;
    isLoaded?: boolean;
    inProgress?: boolean;
    isDetached?: boolean;
    createdAt?: string;
    updatedAt?: string | null;
    surveyJobsMappedPct?: number | null;
    surveyDataCutsUsedPct?: number | null;
    surveyDataCutNameCount?: number | null;
    downloadReportStatus?: Survey.downloadReportStatus | null;
    displayLoadStatus?: Survey.displayLoadStatus;
    surveyReplacements?: Array<SurveyReplacement>;
    publishedSurveyReplacements?: Array<SurveyReplacement>;
    currency?: Array<{
        id: string;
    }>;
};

export namespace Survey {

    export enum downloadReportStatus {
        SCHEDULED = 'SCHEDULED',
        IN_PROGRESS = 'IN_PROGRESS',
        READY = 'READY',
        FAILED = 'FAILED',
    }

    export enum displayLoadStatus {
        EMPTY = 'EMPTY',
        IN_PROGRESS = 'IN_PROGRESS',
        LOADED = 'LOADED',
        UNDER_REVIEW = 'UNDER_REVIEW',
    }


}

